import { motion } from "framer-motion";
import { Sparkles } from "lucide-react";
import { Reveal, EASE } from "../site/motion";
import { AESTHETICS, IMAGES } from "../site/data";

export const Aesthetics = () => (
  <section id="aesthetics" data-testid="aesthetics-section" className="relative bg-background py-28 md:py-40 overflow-hidden">
    <img
      src={IMAGES.texture}
      alt=""
      aria-hidden="true"
      className="pointer-events-none absolute -right-32 -top-24 w-[520px] h-[520px] object-cover opacity-10 grayscale"
    />
    <div className="relative mx-auto max-w-[1600px] px-6 md:px-10">
      <div className="grid grid-cols-1 md:grid-cols-12 gap-6 mb-16 items-end">
        <Reveal className="md:col-span-8">
          <p className="text-xs font-semibold uppercase tracking-[0.24em] text-secondary mb-4 flex items-center gap-2">
            <Sparkles size={14} /> Aesthetics & Wellness
          </p>
          <h2 className="font-serif font-light text-foreground text-4xl md:text-6xl">
            Care that looks inward — and helps you feel radiant outward.
          </h2>
        </Reveal>
        <Reveal delay={0.1} className="md:col-span-4">
          <p className="text-muted-foreground leading-relaxed">
            Beyond addiction medicine, our family nurse practitioner–led clinic offers aesthetic and wellness treatments designed around confidence, health and renewal.
          </p>
        </Reveal>
      </div>

      <div className="grid grid-cols-1 sm:grid-cols-2 gap-px bg-border border border-border">
        {AESTHETICS.map((a, i) => (
          <motion.div
            key={a.title}
            data-testid={`aesthetic-card-${i}`}
            initial={{ opacity: 0, y: 30 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, margin: "-60px" }}
            transition={{ duration: 0.8, ease: EASE, delay: i * 0.08 }}
            className="group bg-background p-8 md:p-12 min-h-[260px] flex flex-col justify-between hover:bg-muted transition-colors duration-500"
          >
            <span className="font-serif text-5xl text-accent group-hover:text-secondary transition-colors duration-500">{a.no}</span>
            <div>
              <h3 className="font-serif font-light text-foreground text-3xl md:text-4xl mb-4">{a.title}</h3>
              <p className="text-muted-foreground leading-relaxed max-w-md">{a.desc}</p>
            </div>
          </motion.div>
        ))}
      </div>
    </div>
  </section>
);
